"use client";

import { c as _c } from "react/compiler-runtime";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import { useState } from "react";
export default function CreateWaveTermsOfService(t0) {
  const $ = _c(32);
  const {
    waveType,
    terms,
    setTerms
  } = t0;
  const [enabled, setEnabled] = useState(!!terms);
  let t1;
  if ($[0] !== setTerms) {
    t1 = enabled_0 => {
      setEnabled(enabled_0);
      if (!enabled_0) {
        setTerms(null);
      }
    };
    $[0] = setTerms;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onEnabledChange = t1;
  const isApplicableWaveType = waveType === ApiWaveType.Rank || waveType === ApiWaveType.Approve;
  if (!isApplicableWaveType) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h3 className="tw-mb-0 tw-text-lg tw-font-semibold tw-text-iron-100">Participation Terms</h3>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `tw-rounded-full tw-bg-gradient-to-b tw-p-[1px] ${enabled ? "tw-from-primary-300" : "tw-from-iron-600"}`;
  let t4;
  if ($[3] !== enabled || $[4] !== onEnabledChange) {
    t4 = () => onEnabledChange(!enabled);
    $[3] = enabled;
    $[4] = onEnabledChange;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== enabled || $[7] !== t4) {
    t5 = <input id="tos-toggle" type="checkbox" checked={enabled} onChange={t4} className="tw-sr-only" />;
    $[6] = enabled;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = `tw-p-0 tw-relative tw-flex tw-items-center tw-h-6 tw-w-11 tw-flex-shrink-0 tw-cursor-pointer tw-rounded-full tw-border-2 tw-border-transparent tw-transition-colors tw-duration-200 tw-ease-in-out focus:tw-outline-none ${enabled ? "tw-bg-primary-500 focus-focus:tw-ring-2 focus-visible:tw-ring-primary-500 focus-visible:tw-ring-offset-2" : "tw-bg-iron-700"}`;
  const t7 = `tw-pointer-events-none tw-inline-block tw-h-5 tw-w-5 tw-transform tw-rounded-full tw-bg-iron-50 tw-shadow tw-ring-0 tw-transition tw-duration-200 tw-ease-in-out ${enabled ? "tw-translate-x-5" : "tw-translate-x-0"}`;
  let t8;
  if ($[9] !== t7) {
    t8 = <span aria-hidden="true" className={t7} />;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== enabled || $[12] !== t6 || $[13] !== t8) {
    t9 = <span className={t6} role="switch" aria-checked={enabled}>{t8}</span>;
    $[11] = enabled;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t3 || $[16] !== t5 || $[17] !== t9) {
    t10 = <div className={t3}>{t5}{t9}</div>;
    $[15] = t3;
    $[16] = t5;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="tw-mb-0 tw-text-sm sm:tw-text-base tw-font-semibold tw-text-iron-50 tw-whitespace-nowrap">Enable Terms</span>;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10) {
    t12 = <div className="tw-flex tw-items-center tw-justify-between">{t2}<label htmlFor="tos-toggle" className="tw-flex tw-cursor-pointer"><div className="tw-flex tw-items-center tw-gap-x-2 sm:tw-gap-x-3">{t10}{t11}</div></label></div>;
    $[20] = t10;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <p className="tw-text-sm tw-text-iron-300 tw-mt-1">Add custom terms that participants must agree to and sign with their wallet before submitting content.</p>;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t12) {
    t14 = <div>{t12}{t13}</div>;
    $[23] = t12;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== enabled || $[26] !== setTerms || $[27] !== terms) {
    t15 = enabled && <div className="tw-mt-4"><div className="tw-group tw-w-full tw-relative"><textarea value={terms ?? ""} onChange={e => setTerms(e.target.value)} id="terms-of-service-text" rows={6} className="tw-ring-iron-650 focus:tw-border-blue-500 focus:tw-ring-primary-400 tw-caret-primary-400 tw-form-textarea tw-block tw-px-4 tw-py-4 tw-w-full tw-text-base tw-rounded-lg tw-border-0 tw-appearance-none tw-text-white tw-border-iron-600 tw-peer tw-bg-iron-900 focus:tw-bg-iron-900 tw-font-medium tw-shadow-sm tw-ring-1 tw-ring-inset placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset tw-transition tw-duration-300 tw-ease-out" placeholder="Enter the terms of service that participants will need to agree to and sign..." /></div><div className="tw-mt-2 tw-flex tw-justify-between tw-text-xs tw-text-iron-400"><span>Participants will need to sign these terms with their wallet</span><span>{terms?.length ?? 0} characters</span></div></div>;
    $[25] = enabled;
    $[26] = setTerms;
    $[27] = terms;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t14 || $[30] !== t15) {
    t16 = <div className="tw-space-y-4">{t14}{t15}</div>;
    $[29] = t14;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
}